import { Error } from './PasswordError.styles';
import { IPasswordErrorProps } from './PasswordError.d';

export const PasswordError = ({ status, errorCopy }: IPasswordErrorProps) => {
    return <Error status={status}>{errorCopy}</Error>;
};
